<template>
  <section class="proposal">
    <div class="container container-full-width-small px-0">
      <div class="container card card-body card-full-width-mobile mt-3 mt-md-9 p-0 p-lg-8">
        <loader v-if="!iquoteId"></loader> 
        <div class="m-4" v-else>
          <h2 class="text-primary mb-3">Gefeliciteerd met uw overstap op zonne-energie!</h2>
          <p>Fijn dat u als huurder van {{ company.name }} heeft gekozen voor zonnepanelen. U
            ontvangt een email met een bevestiging van de overeenkomst. Geen mail ontvangen
            (ook niet in uw spambox)? Bel ons dan even op 020 309 09 01.
          </p>
          <p>Op een zonnige toekomst,<br>Sungevity</p>
          <p>Hieronder vindt u een overzicht van uw bestelling:</p>
          <B2bConfirmationSavingsDetail></B2bConfirmationSavingsDetail>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import B2bConfirmationSavingsDetail from '@/components/b2b/B2bConfirmationSavingsDetail'
import { mapGetters } from 'vuex'
export default {
  name: 'B2bConfirmation',
  components: {
    B2bConfirmationSavingsDetail
  },
  computed: {
    ...mapGetters(['company', 'iquoteId'])
  },
}
</script>